export default __webpack_public_path__ + "static/media/gestureSensor.86e10d4f.svg";